import { render, staticRenderFns } from "./MissingNamesComponent.vue?vue&type=template&id=9197efba&scoped=true"
import script from "./MissingNamesComponent.vue?vue&type=script&lang=js"
export * from "./MissingNamesComponent.vue?vue&type=script&lang=js"
import style0 from "./MissingNamesComponent.vue?vue&type=style&index=0&id=9197efba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9197efba",
  null
  
)

export default component.exports